import SlimSelect from 'slim-select';

export class SubmenuSelectController {
  private readonly submenuElement: HTMLSelectElement | null = document.querySelector('.js-submenuSelect');

  constructor() {
    if (this.submenuElement) {
      const options = this.submenuElement.querySelectorAll('option');
      const select = new SlimSelect({
        select: this.submenuElement,
        showSearch: false,
        onChange: (info: any) => {
          if (info.data.selected !== '1' && info.data.url) {
            window.location = info.data.url;
          }
        },
      });

      options.forEach((option) => {
        if (option.dataset.selected === '1') {
          select.setSelected(option.value);
        }
      });
    }
  }
}
